import { Select, Tag, Tooltip } from "antd";

const SelectList = ({ placeholder, options, filters, setFilters, entity }) => {
  const tagRenderForSelect = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        style={{
          background: "var(--explore-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          height: "28px",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };
  const handleOnChange = (value) => {
    setFilters({
      ...filters,
      [`${entity}`]: value,
    });
  };
  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  return (
    <Select
      value={filters[`${entity}`]}
      mode="multiple"
      allowClear
      className="filter-item"
      showSearch
      tagRender={tagRenderForSelect}
      placeholder={placeholder}
      optionFilterProp="children"
      onChange={handleOnChange}
      filterOption={filterOption}
      options={options}
      style={{ width: "100%", marginBottom: "10px", height: "40px" }}
    />
  );
};

export default SelectList;
